import React from 'react'
import { useTranslation } from 'react-i18next';
import ReservationsList from './ReservationsList';
import MyAccountAccountFilter from '../MyAccountAccountFilter';
import CatchUpLessonsBanner from './SwimmingSchool/CatchUpLessonsBanner';
import useReservationsList from './useReservationsList';

const ReservationsTab = () => {
    const { t } = useTranslation();
    const reservationsListState = useReservationsList();

  return (
    <div className="tab-content__container">
        <h5>{t('twoje_rezerwacje')}</h5>

        <MyAccountAccountFilter />

        <CatchUpLessonsBanner
          sortedTickets={reservationsListState.sortedTickets}
          refreshTickets={reservationsListState.refreshTickets}
        />

        <ReservationsList {...reservationsListState} />
    </div>
  )
}

export default ReservationsTab
